import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-image-dialog',
  template: `
    <div class="flex" mat-dialog-title>
      <span class="flex-1"></span>
      <button mat-dialog-close mat-icon-button type="button">
        <mat-icon size="24px">close</mat-icon>
      </button>
    </div>
    <mat-dialog-content>
      <img *ngIf="data.image" [src]="data.image" style="max-width: 100%">
      <div *ngIf="data.images" >
        <img *ngFor="let image of data.images" [src]="image.file.content" style="max-width: 100%; margin-bottom: 20px">
      </div>
    </mat-dialog-content>
   `,
  styles: [
  ]
})
export class ImageDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
  }

}
